import React from 'react';
import GygWidgetEmbed, { type GygWidgetEmbedProps } from './GygWidgetEmbed';

export type GygActivityWidgetProps = Omit<GygWidgetEmbedProps, 'widgetType'>;

const GygActivityWidget: React.FC<GygActivityWidgetProps> = (props) => (
  <GygWidgetEmbed {...props} widgetType="activities" numberOfItems={props.numberOfItems ?? 3} />
);

export default GygActivityWidget;
